import "./Skills.css";
import {
  FaVideo,
  FaCamera,
  FaFilm,
  FaAd,
  FaEdit,
  FaPaintBrush,
  FaCubes,
  FaPlay,
} from "react-icons/fa";

function Skills() {
  const skills = [
    {
      name: "Video Editing",
      icon: <FaVideo />,
      desc: "Professional editing with cinematic transitions and storytelling.",
    },
    {
      name: "Cinematography",
      icon: <FaCamera />,
      desc: "Capturing visually stunning shots with creative camera techniques.",
    },
    {
      name: "Filmmaking",
      icon: <FaFilm />,
      desc: "Complete production workflow from concept to final delivery.",
    },
    {
      name: "Product Videography",
      icon: <FaPlay />,
      desc: "High-converting product videos for brands and businesses.",
    },
    {
      name: "Product Photography",
      icon: <FaCamera />,
      desc: "Professional product photography for marketing and eCommerce.",
    },
    {
      name: "Brand Shoots",
      icon: <FaCubes />,
      desc: "Creative visual content that strengthens brand identity.",
    },
    {
      name: "Content Creation",
      icon: <FaEdit />,
      desc: "Engaging content tailored for social media platforms.",
    },
    {
      name: "Visual Storytelling",
      icon: <FaFilm />,
      desc: "Turning ideas into impactful visual experiences.",
    },
    {
      name: "Color Correction & Grading",
      icon: <FaPaintBrush />,
      desc: "Professional cinematic color enhancement and grading.",
    },
    {
      name: "Adobe Premiere Pro",
      icon: <FaVideo />,
      desc: "Advanced video editing and post-production expertise.",
    },
    {
      name: "After Effects",
      icon: <FaAd />,
      desc: "Motion graphics, animations and visual effects creation.",
    },
    {
      name: "CapCut",
      icon: <FaEdit />,
      desc: "Fast-paced social media edits optimized for engagement.",
    },
  ];

  return (
    <section className="skills-page">
      <div className="skills-container">
        <span className="skills-tag">MY EXPERTISE</span>

        <h1>Professional Skills</h1>

        <p className="skills-desc">
          A blend of creative vision and technical expertise in
          video production, filmmaking, and digital storytelling.
        </p>

        <div className="skills-grid">
          {skills.map((skill, index) => (
            <div className="skill-card" key={index}>
              <div className="skill-icon">
                {skill.icon}
              </div>

              <h3>{skill.name}</h3>

              <p>{skill.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;